import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/success-view.svg'


const _hoisted_1 = { class: "content-view container py-3" }
const _hoisted_2 = { class: "row mt-5" }
const _hoisted_3 = { class: "col-12 col-lg-6" }
const _hoisted_4 = { class: "what-now-container mb-4 p-4" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "check-process-container p-4" }
const _hoisted_7 = { class: "fs-6 text-start" }
const _hoisted_8 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Contact = _resolveComponent("Contact")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "w-100 fw-600 text-start mt-5" }, " Sua solicitação foi enviada com sucesso! ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "what-now-title text-start mb-4" }, " O que vai acontecer agora? ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMessages, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: message,
              class: "d-flex align-items-start mb-2"
            }, [
              _createVNode(_component_Icon, {
                class: "icon pe-2",
                name: "circle-check",
                style: {"color":"var(--color-success)"}
              }),
              _createElementVNode("p", {
                class: "fs-6 text-start",
                innerHTML: message
              }, null, 8, _hoisted_5)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "check-process-title text-start mb-4" }, " Enquanto isso você pode consultar o andamento da sua solicitação. ", -1)),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_7, [
              _cache[3] || (_cache[3] = _createTextVNode(" Código da solicitação: ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.solicitationCode) + "  ", 1),
              _createVNode(_component_Icon, {
                id: "copy-solicitation-code-icon",
                name: "copy",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyToClipboard(_ctx.solicitationCode))),
                onMouseleave: _ctx.resetContent
              }, null, 8, ["onMouseleave"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary btn-sm",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openNewTab && _ctx.openNewTab(...args)))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("span", { class: "me-2" }, "Consultar andamento", -1)),
              _createVNode(_component_Icon, { name: "magnifying-glass" })
            ])
          ])
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-none d-lg-block col-6 d-flex justify-content-center" }, [
        _createElementVNode("img", {
          id: "validation-success-image",
          src: _imports_0,
          alt: "domain-validation"
        })
      ], -1))
    ]),
    _createVNode(_component_Contact)
  ]))
}